import { render, staticRenderFns } from "./FormBoolean.vue?vue&type=template&id=c980d308&"
import script from "./FormBoolean.vue?vue&type=script&lang=js&"
export * from "./FormBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports